export default __webpack_public_path__ + "static/media/big-sized-sofa.17175035.png";